import React, { useCallback, useEffect, useMemo, useState } from "react";
import * as RB from "react-bootstrap";
import DataTable from "react-data-table-component";
import FilterComponent from "../FilterComponent";
import Swal from "sweetalert2";
import EditIcon from "@mui/icons-material/Edit";
import { Delete } from "@mui/icons-material";
import * as utils from "../../Utils/comman";
import { useSelector } from "react-redux";
import {
  Check,
  CloseCircle,
  DocumentDownload,
  Edit,
  Edit2,
  Eye,
  PauseCircle,
  ProfileAdd,
  TickCircle,
  Trash,
} from "iconsax-react";
import ReasonModal from "../ReasonModal";
import RejectModal from "./RejectModal";
import LogModal from "./LogModal";
import StoreManagerApprovalModal from "./StoreManagerApprovalModal";
import { useLoader } from "../../Loader";
import Select from "react-select";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import CustomPagination from "../../Utils/CustomPagination";

function List(props) {
  const [purchaseOrder, setPurchaseOrder] = useState([]);
  const [createPurchaseOrder, setcreatePurchaseOrder] = useState([]);
  const [page, setPage] = useState(1);
  const countPerPage = 10;
  const [filterText, setFilterText] = useState("");
  const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [modalTitle, setModalTitle] = useState("");
  const [modalText, setModalText] = useState("");
  const [showRejectModal, setShowRejectModal] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [id, setId] = useState("");
  const handleShowModal = useCallback(
    (title, text) => () => {
      setModalTitle(title);
      setModalText(text);
      setShowModal(true);
    },
    []
  );
  const userProfile = useSelector((state) => state.userProfile.userProfile);
  const userRole = userProfile?.user_role[0]?.roleName;
  const [showLogModal, setShowLogModal] = useState(false);
  const [currentLog, setCurrentLogs] = useState([]);
  const [action, setAction] = useState("");
  const [poNo, setPoNo] = useState("");
  const [poType, setPoType] = useState("");
  const [vendorId, setVendorId] = useState("");
  const [vendors, setVendors] = useState([]);
  const [dateRange, setDateRange] = useState([null, null]);
  const [startDate, endDate] = dateRange;
  const [isSearch, setIsSearch] = useState("");
  const primaryMenuRes = useSelector(
    (state) => state?.primaryMenu?.primaryMenu?.permissions
  );
  const [showApprovalModal, setShowApprovalModal] = useState(false);
  const { startLoader, stopLoader } = useLoader();

  const handleAddClick = (order) => {
    const propdata = {
      mode: "add",
    };
    props.onChange(propdata);
    props.setCurrentorder(order);
  };

  const permissions = [
    {
      approve: "purchase_order.I&D_approve",
      reject: "purchase_order.I&D_reject",
      titleA: "I&D Approval",
      titleR: "I&D Reject",
      status: ["1"],
    },
    {
      approve: "purchase_order.R&D_approve",
      reject: "purchase_order.R&D_reject",
      titleA: "R&D Approval",
      titleR: "R&D Reject",
      status: ["2"],
    },
    {
      approve: "purchase_order.OH_approve",
      reject: "purchase_order.OH_reject",
      titleA: "OH Approval",
      titleR: "OH Reject",
      status: ["3"],
    },
    {
      approve: "purchase_order.CFO_approve",
      reject: "purchase_order.CFO_reject",
      titleA: "CFO Approval",
      titleR: "CFO Reject",
      status: ["4"],
    },
    {
      approve: "purchase_order.CEO_approve",
      reject: "purchase_order.CEO_reject",
      titleA: "CEO Approval",
      titleR: "CEO Reject",
      status: ["4"],
    },
    // {
    //   approve: "purchase_order.STORE_approve",
    //   reject: "purchase_order.STORE_reject",
    //   title: "Store Approval",
    // },
    {
      approve: "purchase_order.QC_approve",
      reject: "purchase_order.QC_reject",
      titleA: "QC Approval",
      titleR: "QC Reject",
      status: ["7", "11"],
    },
  ];

  const renderPermissionButtons = (row) =>
    permissions
      .filter((perm) => perm.status.includes(row.status))
      .map((perm, index) => (
        <React.Fragment key={index}>
          {utils.hasPermission(
            primaryMenuRes,
            "Purchase Order",
            perm.approve
          ) && (
            <RB.Button
              className="btn-flat me-1"
              title={`${perm.titleA}`}
              onClick={handleApprove(row)}
            >
              <TickCircle />
            </RB.Button>
          )}
          {utils.hasPermission(
            primaryMenuRes,
            "Purchase Order",
            perm.reject
          ) && (
            <RB.Button
              className="btn-flat me-1"
              title={`${perm.titleR}`}
              onClick={handleReject(row)}
            >
              <CloseCircle />
            </RB.Button>
          )}
        </React.Fragment>
      ));

  const columns = [
    {
      name: (
        <div>
          Purchase Order Number <br />
        </div>
      ),
      selector: (row) => row.order_id,
      width: "165px",
    },
    {
      name: (
        <div>
          Purchase Order <br />
        </div>
      ),
      selector: (row) => row.head_name,
    },
    {
      name: (
        <div>
          Order Date <br />
        </div>
      ),
      selector: (row) => row.order_date,
    },
    {
      name: (
        <div>
          Delivery Date <br />
        </div>
      ),
      selector: (row) => row.delivery_date,
    },
    {
      name: (
        <div>
          Vendor Name <br />
        </div>
      ),
      selector: (row) => row.companyName,
    },
    {
      name: (
        <div>
          Delivery Period <br />
        </div>
      ),
      selector: (row) => row.delivery_period,
    },
    {
      name: "Remark",
      selector: (row) => row.remarks,
      cell: (row) => {
        const wordCount = row?.remarks?.split(" ").length;
        return wordCount > 2 ? (
          <RB.Button
            className="btn btn-flat"
            onClick={handleShowModal("Remark", row.remarks)}
          >
            <Eye />
          </RB.Button>
        ) : (
          <span>{row.remarks}</span>
        );
      },
    },
    {
      name: (
        <div>
          Purchase Order Logs <br />
        </div>
      ),
      cell: (row) => (
        <>
          <RB.Button
            className="btn-flat me-1"
            title="View"
            onClick={handleLogView(row)}
          >
            <Eye />
          </RB.Button>
        </>
      ),
    },
    {
      name: "Status",
      selector: (row) => row.status_label,
      cell: (row) => {
        const wordCount = row?.status_label?.split(" ").length;
        return wordCount > 1 ? (
          <RB.Button
            className="btn btn-flat"
            onClick={handleShowModal("Purchase Order Status", row.status_label)}
          >
            <Eye />
          </RB.Button>
        ) : (
          <span>{row.status_label}</span>
        );
      },
    },
    {
      name: "Action",
      center: true,
      cell: (row) => (
        <>
          {utils.hasPermission(
            primaryMenuRes,
            "Purchase Order",
            "purchase_order.edit"
          ) && (
            <>
              {(row.status_label == "Pending" ||
                row.status_label == "Rejected") && (
                <RB.Button
                  className="btn-flat me-1"
                  title="Edit"
                  onClick={handelEdit(row)}
                >
                  <Edit2 />
                </RB.Button>
              )}
            </>
          )}
          <RB.Button
            className="btn-flat me-1"
            title="View"
            onClick={handleView(row)}
          >
            <Eye />
          </RB.Button>
          {utils.hasPermission(
            primaryMenuRes,
            "Purchase Order",
            "purchase_order.delete"
          ) && (
            <>
              {(row.status_label == "Pending" ||
                row.status_label == "Rejected") && (
                <RB.Button
                  className="btn-flat me-1"
                  // title="Delete"
                  onClick={showDelete(row)}
                >
                  <Trash />
                </RB.Button>
              )}
            </>
          )}
          {renderPermissionButtons(row)}
          {utils.hasPermission(
            primaryMenuRes,
            "Purchase Order",
            "purchase_order.QC_hold"
          ) && (
            <>
              {row?.status == "7" && (
                <RB.Button
                  className="btn-flat me-1"
                  title="Hold"
                  onClick={handleHold(row)}
                >
                  <PauseCircle />
                </RB.Button>
              )}
            </>
          )}
          {utils.hasPermission(
            primaryMenuRes,
            "Purchase Order",
            "purchase_order.store_manager_approve"
          ) && (
            <>
              {row.status == "5" && (
                <RB.Button
                  className="btn-flat me-1"
                  title="Store Approve"
                  onClick={handleStoreManagerApprove(row)}
                >
                  <TickCircle />
                </RB.Button>
              )}
            </>
          )}
          {utils.hasPermission(
            primaryMenuRes,
            "Purchase Order",
            "purchase_order.store_manager_reject"
          ) && (
            <>
              {row.status == "5" && (
                <RB.Button
                  className="btn-flat me-1"
                  title="Store Reject"
                  onClick={handleReject(row)}
                >
                  <CloseCircle />
                </RB.Button>
              )}
            </>
          )}
          {utils.hasPermission(
            primaryMenuRes,
            "Purchase Order",
            "purchase_order.accountant_approve"
          ) && (
            <RB.Button
              className="btn-flat me-1"
              // title="Delete"
              onClick={handleFixedAssets(row)}
            >
              <TickCircle />
            </RB.Button>
          )}
        </>
      ),
    },
  ];

  useEffect(() => {
    getPurchaseOrder();
  }, [page, filterText]);

  useEffect(() => {
    getVendors();
    getCreatePurchaseOrder();
  }, []);

  const getPurchaseOrder = () => {
    startLoader();
    const fromDate = startDate ? moment(startDate).format("YYYY-MM-DD") : "";
    const toDate = endDate ? moment(endDate).format("YYYY-MM-DD") : "";
    utils
      .callAPI(
        "get",
        `/purchaseorder/list?page=${page}&per_page=${countPerPage}&po_head_id=${poType}&vendor_id=${vendorId}&from_date=${fromDate}&to_date=${toDate}&po_no=${poNo}`
      )
      .then((res) => {
        if (typeof res !== "undefined") {
          setPurchaseOrder(res);
          stopLoader();
          setIsSearch("");
        } else {
          setPurchaseOrder([]);
          setIsSearch("");

          stopLoader();
        }
      })
      .catch((err) => {
        setPurchaseOrder([]);
        setIsSearch("");

        stopLoader();
      });
  };

  const getCreatePurchaseOrder = () => {
    startLoader();
    utils
      .callAPI("get", `purchaseorder/head/list`)
      .then((res) => {
        if (typeof res !== "undefined") {
          setcreatePurchaseOrder(res);
          stopLoader();
        } else {
          setcreatePurchaseOrder([]);
          stopLoader();
        }
      })
      .catch((err) => {
        setcreatePurchaseOrder([]);
        stopLoader();
      });
  };

  const getVendors = () => {
    utils
      .callAPI(
        "get",
        `/vendors/listAll?created_by=&company_name=&name=&contact_no=&gst_no=&state=&deal_item=`
      )
      .then((res) => {
        if (typeof res !== "undefined") {
          const activeVendors = res.result.filter(
            (vendor) => vendor.status === "1"
          );
          setVendors([
            { id: "", companyName: "Select Vendor..." },
            ...activeVendors,
          ]);
        }
      })
      .catch(() => {
        setVendors([]);
      });
  };

  const handleStoreManagerApprove = useCallback((row) => async () => {
    setSelectedOrder(row);
    setShowApprovalModal(true);
  });

  const handleApprove = useCallback((row) => async () => {
    startLoader();
    var bodyFormData = new FormData();
    bodyFormData.append("po_id", row.id);
    bodyFormData.append("status", "accept");
    bodyFormData.append("reject_reason", "");

    utils
      .callAPI("post", `purchaseorder/change-status`, bodyFormData)
      .then((res) => {
        if (typeof res !== "undefined") {
          getPurchaseOrder();
          stopLoader();
        } else {
          getPurchaseOrder();
          stopLoader();
        }
      })
      .catch((err) => {
        getPurchaseOrder();
        stopLoader();
      });
  });

  const handleReject = useCallback((row) => async () => {
    setAction("reject");
    setSelectedOrder(row);
    setShowRejectModal(true);
  });

  const handleHold = useCallback((row) => async () => {
    setAction("hold");
    setSelectedOrder(row);
    setShowRejectModal(true);
  });

  const handelEdit = useCallback((row) => async () => {
    const propdata = {
      mode: "edit",
      rowData: row,
    };
    props.onChange(propdata);
    props.setCurrentorder(row);
  });

  const handleView = useCallback((row) => async () => {
    const propdata = {
      mode: "view",
      rowData: row,
    };
    props.onChange(propdata);
  });

  const handleFixedAssets = useCallback((row) => async () => {
    const propdata = {
      mode: "fixed",
      rowData: row,
    };
    props.onChange(propdata);
  });

  const handleLogView = useCallback((row) => async () => {
    setCurrentLogs(row.po_log);
    setShowLogModal(true);
  });

  const showDelete = useCallback((row) => async () => {
    Swal.fire({
      title: "Are you sure?",
      text: "Once deleted, you will not be able to recover this data!",
      icon: "warning",
      showDenyButton: true,
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        utils
          .callAPI("get", `/purchaseorder/delete?id=${row.id}`, "")
          .then((res) => {
            if (typeof res !== "undefined") {
              getPurchaseOrder();
            }
          })
          .catch((err) => {});
      }
    });
  });

  const handleRejects = (comment) => {};

  const handleSearch = () => {
    setIsSearch("search");
  };

  const handleReset = () => {
    setPoNo("");
    setPoType("");
    setVendorId("");
    setDateRange([null, null]);
    setIsSearch("reset");
  };

  useEffect(() => {
    if (isSearch == "search" || isSearch == "reset") {
      getPurchaseOrder();
    }
  }, [isSearch]);

  const vendorOptions = vendors.map((vendor) => ({
    value: vendor.id,
    label: vendor.companyName,
  }));

  const handlePageChange = (newPage) => {
    setPage(newPage);
  };

  // --- helpers ---
  const toNum = (x) => {
    if (x == null || x === "") return 0;
    const n = Number(String(x).replace(/,/g, "").trim());
    return Number.isFinite(n) ? n : 0;
  };
  const numCell = (n) => toNum(n).toFixed(2);
  const textCell = (val) => {
    const s = String(val ?? "");
    const flat = s.replace(/\r?\n|\r/g, " ").trim(); // remove line breaks so Excel doesn't stretch columns
    return /[",]/.test(flat) ? `"${flat.replace(/"/g, '""')}"` : flat;
  };

  // --- recompute total (number-safe) ---
  const getTotal = (po) => {
    const amount = (po.po_items || []).reduce(
      (sum, it) => sum + toNum(it.amount),
      0
    );
    const cgst = (po.po_items || []).reduce(
      (sum, it) => sum + toNum(it.cgst_amt),
      0
    );
    const sgst = (po.po_items || []).reduce(
      (sum, it) => sum + toNum(it.sgst_amt),
      0
    );
    const igst = (po.po_items || []).reduce(
      (sum, it) => sum + toNum(it.igst_amt),
      0
    );
    const pack = toNum(po.packing_charge);
    const trans = toNum(po.transport_charge);
    const other = toNum(po.other_charge);
    return amount + cgst + sgst + igst + pack + trans + other;
  };

  // --- download ---
  const handleDownload = () => {
    const fromDate = startDate ? moment(startDate).format("YYYY-MM-DD") : "";
    const toDate = endDate ? moment(endDate).format("YYYY-MM-DD") : "";

    // 🚫 If user has store or QC permission — hide pricing columns
    const hasUserPermission =
      utils.hasPermission(
        primaryMenuRes,
        "Purchase Order",
        "purchase_order.list_for_store"
      ) ||
      utils.hasPermission(
        primaryMenuRes,
        "Purchase Order",
        "purchase_order.list_for_QC"
      );

    utils
      .callAPI(
        "get",
        `/purchaseorder/list?page=0&per_page=0&po_head_id=${poType}&vendor_id=${vendorId}&from_date=${fromDate}&to_date=${toDate}&po_no=${poNo}`
      )
      .then((res) => {
        const rows = Array.isArray(res?.result) ? res.result : [];
        if (!rows.length) return;

        // ===== Build header dynamically =====
        const headerParts = [
          "Purchase Order Number",
          "Purchase Order Type",
          "Order Date",
          "Delivery Date",
          "Vendor Name",
          "Delivery Period",
          "Terms Of Payment",
          "Shipping Location",
          "Billing Location",
          "RM Code",
        ];

        // Only include pricing columns if user does NOT have restricted permission
        if (!hasUserPermission) {
          headerParts.push(
            "Amount",
            "Packing & Forwarding",
            "Transportation",
            "Other",
            "CGST",
            "SGST",
            "IGST",
            "Total Amount"
          );
        }

        const header = headerParts.join(",");

        // ===== Build CSV rows =====
        const csvRows = rows.map((po) => {
          const amount = (po.po_items || []).reduce(
            (s, it) => s + toNum(it.amount),
            0
          );
          const cgst = (po.po_items || []).reduce(
            (s, it) => s + toNum(it.cgst_amt),
            0
          );
          const sgst = (po.po_items || []).reduce(
            (s, it) => s + toNum(it.sgst_amt),
            0
          );
          const igst = (po.po_items || []).reduce(
            (s, it) => s + toNum(it.igst_amt),
            0
          );
          const pack = toNum(po.packing_charge);
          const trans = toNum(po.transport_charge);
          const other = toNum(po.other_charge);
          const grand = getTotal(po);

          const shipping = [
            po.location_name,
            po.address,
            po.city,
            po.district,
            po.state,
            po?.pincode,
          ]
            .filter(Boolean)
            .join(", ");

          const billing = [
            po.billing_company_name,
            po.billing_address,
            po.billing_city_name,
            po.billing_district_name,
            po.billing_state_name,
            po?.pincode,
          ]
            .filter(Boolean)
            .join(", ");

          const parts = [
            textCell(po.order_id),
            textCell(po.head_name),
            textCell(po.order_date),
            textCell(po.delivery_date),
            textCell(po.companyName),
            textCell(po.delivery_period),
            textCell(po.terms_of_payment),
            textCell(shipping),
            textCell(billing),
            textCell(po.rm_code),
          ];

          // Pricing values are added only if user has access
          if (!hasUserPermission) {
            parts.push(
              numCell(amount),
              numCell(pack),
              numCell(trans),
              numCell(other),
              numCell(cgst),
              numCell(sgst),
              numCell(igst),
              numCell(grand)
            );
          }

          return parts.join(",");
        });

        // ===== Export CSV =====
        const csv = ["\uFEFF" + header, ...csvRows].join("\n");
        const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = "Purchase_Orders.csv";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(link.href);
      })
      .catch(() => {});
  };

  return (
    <>
      <div className="section-body">
        <RB.Card className="card shadow ">
          <RB.Card.Header>
            <h4></h4>
            <div className="card-header-action">
              {utils.hasPermission(
                primaryMenuRes,
                "Purchase Order",
                "purchase_order.create"
              ) && (
                //   <RB.Button
                //     className="btn btn-primary me-2"
                //     onClick={handleAddClick}
                //   >
                //     Create Purchase Order
                //   </RB.Button>
                <RB.Dropdown data-bs-theme="primary">
                  <RB.Dropdown.Toggle
                    id="dropdown-button-dark-example1"
                    variant="primary"
                  >
                    Create Purchase Order
                  </RB.Dropdown.Toggle>

                  <RB.Dropdown.Menu>
                    {createPurchaseOrder?.result?.map((order) => (
                      <RB.Dropdown.Item
                        key={order.id}
                        onClick={() => handleAddClick(order)}
                      >
                        <strong>{order.head_name}</strong>
                      </RB.Dropdown.Item>
                    ))}
                  </RB.Dropdown.Menu>
                </RB.Dropdown>
              )}
            </div>
            {/* {utils.hasPermission(
              primaryMenuRes,
              "Purchase Order",
              "purchase_order.list_for_store"
            ) ||
            utils.hasPermission(
              primaryMenuRes,
              "Purchase Order",
              "purchase_order.list_for_QC"
            ) ? null : ( */}
              <a
                href="#"
                className="btn btn-primary btn-circle ms-2"
                onClick={handleDownload}
              >
                <DocumentDownload />
              </a>
            {/* )} */}
          </RB.Card.Header>
          <RB.Card.Body>
            {utils.hasPermission(
              primaryMenuRes,
              "Purchase Order",
              "purchase_order.view"
            ) && (
              <>
                <div className="container-fluid">
                  <div className="row g-3 mb-3 align-items-end">
                    {/* PO No */}
                    <div className="col-12 col-md-2">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="PO No"
                        value={poNo}
                        onChange={(e) => setPoNo(e.target.value)}
                      />
                    </div>

                    {/* PO Type */}
                    <div className="col-12 col-md-2">
                      <select
                        className="form-select"
                        value={poType}
                        onChange={(e) => setPoType(e.target.value)}
                      >
                        <option value="">Select PO Type</option>
                        {createPurchaseOrder?.result?.map((order) => (
                          <option key={order.id} value={order.id}>
                            {order.head_name}
                          </option>
                        ))}
                      </select>
                    </div>

                    {/* Vendor Select */}
                    <div className="col-12 col-md-3">
                      <Select
                        options={vendorOptions}
                        value={vendorOptions.find(
                          (option) => option.value === vendorId
                        )}
                        onChange={(selectedOption) =>
                          setVendorId(selectedOption?.value || "")
                        }
                        isSearchable
                        placeholder="Select Vendor"
                      />
                    </div>

                    {/* Date Range Picker */}
                    <div className="col-12 col-md-3">
                      <DatePicker
                        selectsRange
                        startDate={startDate}
                        endDate={endDate}
                        onChange={(update) => setDateRange(update)}
                        isClearable
                        placeholderText="Select date range"
                        className="form-control"
                      />
                    </div>

                    {/* Buttons */}
                    <div className="col-12 col-md-2 d-flex justify-content-md-end justify-content-center gap-2">
                      <button
                        className="btn btn-primary fw-bold"
                        onClick={handleSearch}
                      >
                        Search
                      </button>
                      <button
                        className="btn btn-dark fw-bold"
                        onClick={handleReset}
                      >
                        Reset
                      </button>
                    </div>
                  </div>
                </div>

                <DataTable
                  columns={columns}
                  data={purchaseOrder.result}
                  highlightOnHover
                  responsive
                  pagination
                  paginationServer
                  paginationTotalRows={purchaseOrder.total}
                  paginationPerPage={countPerPage}
                  paginationComponentOptions={{
                    noRowsPerPage: true,
                  }}
                  paginationComponent={() => (
                    <CustomPagination
                      currentPage={page}
                      totalRows={purchaseOrder.total}
                      rowsPerPage={countPerPage}
                      onPageChange={handlePageChange}
                    />
                  )}
                  striped
                  onChangePage={(page) => setPage(page)}
                  persistTableHead
                  customStyles={{
                    head: {
                      style: {
                        fontSize: "0.875rem",
                        fontWeight: "bold",
                      },
                    },
                  }}
                />
              </>
            )}
          </RB.Card.Body>
        </RB.Card>
      </div>
      <ReasonModal
        show={showModal}
        onHide={() => setShowModal(false)}
        title={modalTitle}
        text={modalText}
      />
      <RejectModal
        show={showRejectModal}
        onHide={() => setShowRejectModal(false)}
        onReject={handleReject}
        selectedOrder={selectedOrder}
        getPurchaseOrder={getPurchaseOrder}
        action={action}
      />
      <LogModal
        show={showLogModal}
        onHide={() => setShowLogModal(false)}
        logs={currentLog}
      />
      <StoreManagerApprovalModal
        show={showApprovalModal}
        selectedOrder={selectedOrder}
        onHide={() => setShowApprovalModal(false)}
        getPurchaseOrder={getPurchaseOrder}
      />
    </>
  );
}

export default List;
